import { render, staticRenderFns } from "./PcArea.vue?vue&type=template&id=b57635aa&"
import script from "./PcArea.vue?vue&type=script&lang=js&"
export * from "./PcArea.vue?vue&type=script&lang=js&"
import style0 from "./PcArea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports